import React, { useEffect, useState } from 'react'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import axios from '../../utils/axiosInterceptor';
import TablaProductos from '../inventario/TablaProductos';
import { v4 as uuidv4 } from 'uuid';

import { DateTime } from 'luxon';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import {
    Box, Divider, Typography, Grid, Button, Container, FormControl, TextField, Autocomplete,
    Paper, Dialog, TableRow, TableCell, Table, TableContainer, DialogTitle,
    DialogContent, DialogActions,
    TableHead, TableBody
} from '@mui/material';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';

import { formatMoney } from '../../utils/functions/Utils';

const AgregarPedido = () => {
    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [noPedido, setNoPedido] = useState(0);
    const [suppliers, setSuppliers] = useState([{}]);
    const [categories, setCategories] = useState([{}]);
    const [categoria, setCategoria] = useState('');
    const [proveedor, setProveedor] = useState('');
    const [fechaDePedido, setFechaDePedido] = useState(DateTime.now());
    const [fechaDeEntrega, setFechaDeEntrega] = useState(DateTime.now());

    const [tempProducts, setTempProducts] = useState([]);
    const [products, setProducts] = useState([]);

    const [gastos, setGastos] = useState({
        flete: 0,
        fleteMaritimo: 0,
        releaseFree: 0,
        aduanaImpuesto: 0,
        montacargas: 0,
        policia: 0,
        embalaje: 0,
        manoDeObra: 0,
        gastoDeVentas: 0,
    });

    const [tipoDeCambio, setTipoDeCambio] = useState(20);
    const [subtotalGastos, setSubtotalGastos] = useState(0);

    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' }); // for custom alert message

    useEffect(() => {
        if (auth.user.rol !== "Admin") {
            navigate('/dashboard');
        }
        document.title = 'Agregar Pedido';
    }, [auth])

    // for custom alert message
    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        try {
            let res = await axios.get('/api/suppliers/');
            if (res.status === 200) {
                setSuppliers(res.data);
            }
            res = await axios.get(`/api/configs/company/${auth.user.company}`);
            if (res.status === 200) {
                setCategories(res.data.categorias);
            }
        } catch (err) {
            console.log(err);
        }
    }

    const getUuid = () => { return uuidv4() };

    const handleAddProduct = ({ product }) => {
        let x = {};
        x.id = product._id;
        x.nombre = product.nombre;
        x.clave = product.clave;
        x.cantidadComprada = 1;
        x.costoUnitarioAnteriorMxn = product.costoUnitario;
        x.precioUnitarioAnteriorMxn = product.precioUnitario;
        x.costoUnitario = 0;
        x.costoGeneral = 0;
        x.mixValue = 0;
        x.margen = 100;
        x.precioVentaUsd = Number(x.costoUnitario) * (x.margen / 100);
        x.precioVentaUsdIva = x.precioVentaUsd * 1.16;
        x.precioVenta = x.precioVentaUsd * tipoDeCambio;
        x.precioVentaIva = x.precioVenta * 1.16;
        x.key = getUuid();
        x.descripcion = product.descripcion;
        x.categoria = product.categoria;
        x.imagen = product.imagen;
        setTempProducts(tempProducts => [...tempProducts, x]);
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleAddList = () => {
        setProducts(products => [...products, ...tempProducts]);
        setTempProducts([]);
        setOpen(false);
    }

    const renderSearchModal = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={open}
                className='exo2'
                scroll='paper'
                onClose={handleClose}>
                <DialogTitle >Agregar productos</DialogTitle>
                <DialogContent>
                    <Grid container >
                        <Grid item xs={12} lg={9} >
                            <TablaProductos height={500} cotizacion={true} onAddProduct={handleAddProduct} />
                        </Grid>
                        <Grid item xs={12} lg={3} style={{ padding: '0px 8px' }}>
                            <Divider className='my-3' textAlign="left">
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Productos selecionados' className='text-bold' />
                            </Divider>
                            <TableContainer>
                                <Table>
                                    <TableHead sx={{ borderBottom: 'solid 1px black' }}>
                                        <TableRow>
                                            <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '14px' }}>Clave</TableCell>
                                            <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '14px' }}>Refacción</TableCell>
                                            <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '14px' }}>Precio Unitario</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            tempProducts.length > 0 ? tempProducts.map((ref, i) => (
                                                <TableRow key={i}>
                                                    <TableCell size='small' align='center' sx={{ fontSize: '14px' }}>{ref.clave}</TableCell>
                                                    <TableCell size='small' align='center' sx={{ fontSize: '14px' }}>{ref.nombre}</TableCell>
                                                    <TableCell size='small' align='center' sx={{ fontSize: '14px' }}>$ {formatMoney(ref.precioUnitario)}</TableCell>
                                                </TableRow>
                                            )) : <TableRow>
                                                <TableCell size='small' align='center' colSpan={3} sx={{ fontSize: '1em' }}>No ha selecionado ninguna refacción</TableCell>
                                            </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color='success' variant='contained' onClick={() => handleAddList()}>Agregar productos &nbsp; <i className="fad fa-plus-circle"></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    const editProduct = (e, id) => {
        let x = products.find(x => x.id === id);
        x[e.target.name] = e.target.value;
        x.costoGeneral = Number(x.cantidadComprada) * Number(x.costoUnitario);
        x.costoTotal = Number(subtotalGastos) * (Number(x.mixValue) / 100) + Number(x.costoGeneral);
        x.costoUnitarioTotal = Number(x.costoTotal) / Number(x.cantidadComprada);
        x.precioVentaUsd = (x.margen / 100) * Number(x.costoUnitario);
        x.precioVentaUsdIva = x.precioVentaUsd * 1.16;
        x.precioVenta = x.precioVentaUsd * tipoDeCambio;
        x.precioVentaIva = x.precioVenta * 1.16;

        let subtotal = products.reduce(function (tot, arr) {
            return tot + arr.costoGeneral;
        }, 0);

        products.forEach(x => {
            x.mixValue = (x.costoGeneral / subtotal) * 100;
        });

        setProducts(products => [...products]);
    }

    const handleDelete = (d, r) => {
        if (r < 2) {
            setProducts([]);
        } else {
            setProducts(products.filter(x => x._id !== d));
        }
    }

    const renderProducts = () => {
        if (products.length === 0) return null;
        return (
            <>
                <Divider className='my-3' textAlign="center">
                    <CustomChip variant='outlined' estatus='AUTORIZADO' label='Productos' className='text-bold' />
                </Divider>

                <TableContainer sx={{ backgroundColor: 'comp.boxBg' }}>
                    <Table>
                        <TableHead>
                            <TableRow hover >
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                <TableCell align='left' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                <TableCell align='left' sx={{ fontWeight: '700', fontSize: '1em' }}>Inventario Comprado</TableCell>
                                <TableCell align='left' sx={{ fontWeight: '700', fontSize: '1em' }}>Costo Unitario USD</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Total USD</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Mix Value</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {products.map((ref, i) => (
                                <TableRow hover key={i} >
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='left'>{ref.nombre}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>
                                        <FormControl required sx={{ m: 1, maxWidth: '90px' }} style={{ display: 'flex' }}>
                                            <TextField size='small' name='cantidadComprada' label="Inventario Comprado" variant="outlined" value={ref.cantidadComprada} onChange={(e) => editProduct(e, ref.id)} />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>
                                        <FormControl required sx={{ m: 1, maxWidth: '120px' }} style={{ display: 'flex' }}>
                                            <TextField size="small" name='costoUnitario' label="Costo Unitario USD" variant="outlined" value={ref.costoUnitario} onChange={(e) => editProduct(e, ref.id)} />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.costoGeneral)}`}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{formatMoney(ref.mixValue)} %</TableCell>
                                    <TableCell size='small' align='center'>
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <Button sx={{ minWidth: '50px' }} variant='contained' color='error' className='m-1' onClick={() => handleDelete(ref._id, products.length)}>&nbsp;<i className='fa fa-trash-alt'></i>&nbsp;</Button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <br />
                {/* <div className='d-flex justify-content-end'>
                    <Button variant='contained' color='success' className='m-1' onClick={(e) => handleSubmit(e)}>Guardar &nbsp;&nbsp; <i className='fad fa-save' style={{ transform: 'scale(1.3)' }}></i></Button>
                </div> */}
            </>
        )
    }

    useEffect(() => {
        const total = Object.values(gastos).reduce((t, n) => Number(t) + Number(n))
        setSubtotalGastos(total);
        const tmp = products.map(x => {
            const costoTotal = Number(total) * (Number(x.mixValue) / 100) + Number(x.costoGeneral);
            const costoUnitarioTotal = Number(costoTotal) / Number(x.cantidadComprada);
            const costoUnitarioMxn = (Number(costoTotal) / Number(x.cantidadComprada)) * (Number(tipoDeCambio));
            return { ...x, costoTotal: costoTotal, costoUnitarioTotal: costoUnitarioTotal, costoUnitarioMxn: costoUnitarioMxn }

        })
        setProducts(tmp);
    }, [gastos])

    const renderCostos = () => {
        return (
            <>
                <Divider className='my-3' textAlign="center">
                    <CustomChip variant='outlined' estatus='DIAGNOSTICADO' label='Costos de Importación' className='text-bold' />
                </Divider>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={3}>
                        <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Flete terrestre" variant="outlined" value={gastos.flete} onChange={(e) => setGastos({ ...gastos, flete: e.target.value })} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Flete Maritimo" variant="outlined" value={gastos.fleteMaritimo} onChange={(e) => setGastos({ ...gastos, fleteMaritimo: e.target.value })} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Release Fee/Limpieza" variant="outlined" value={gastos.releaseFree} onChange={(e) => setGastos({ ...gastos, releaseFree: e.target.value })} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Aduana impuesto" variant="outlined" value={gastos.aduanaImpuesto} onChange={(e) => setGastos({ ...gastos, aduanaImpuesto: e.target.value })} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Montacargas" variant="outlined" value={gastos.montacargas} onChange={(e) => setGastos({ ...gastos, montacargas: e.target.value })} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Policias" variant="outlined" value={gastos.policia} onChange={(e) => setGastos({ ...gastos, policia: e.target.value })} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Embalaje" variant="outlined" value={gastos.embalaje} onChange={(e) => setGastos({ ...gastos, embalaje: e.target.value })} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Mano de obra" variant="outlined" value={gastos.manoDeObra} onChange={(e) => setGastos({ ...gastos, manoDeObra: e.target.value })} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Gasto de ventas" variant="outlined" value={gastos.gastoDeVentas} onChange={(e) => setGastos({ ...gastos, gastoDeVentas: e.target.value })} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                            <TextField size='small' label="Tipo de Cambio" variant="outlined" value={tipoDeCambio} onChange={(e) => setTipoDeCambio(e.target.value)} />
                        </FormControl>
                    </Grid>
                </Grid>
            </>
        )
    }

    const renderCostosTable = () => {
        if (products.length === 0) return null;
        return (
            <>
                <br />

                <TableContainer sx={{ backgroundColor: '#C147E922' }}>
                    <Table>
                        <TableHead>
                            <TableRow hover >
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Flete Terrestre</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Flete Maritimo</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Release Fee/Limpieza</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Aduana Impuesto</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Montacargas</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Policias</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Embalaje</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Mano de obra</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Gasto de ventas</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {products.map((ref, i) => (
                                <TableRow hover key={i} >
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.flete, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.fleteMaritimo, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.releaseFree, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.aduanaImpuesto, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.montacargas, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.policia, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.embalaje, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.manoDeObra, ref.mixValue)}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{calculateMixValue(gastos.gastoDeVentas, ref.mixValue)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <br />
                <TableContainer sx={{ backgroundColor: '#C147E911' }}>
                    <Table>
                        <TableHead>
                            <TableRow hover >
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Subtotal</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Tipo de Cambio</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow hover >
                                <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>$ {formatMoney(subtotalGastos)}</TableCell>
                                <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>$ {formatMoney(tipoDeCambio)}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </>
        )
    }

    const calculateMixValue = (value, mixValue) => {
        return formatMoney(value * mixValue / 100);
    }

    const editMargen = (e, id) => {
        let x = products.find(x => x.id === id);
        x[e.target.name] = Number(e.target.value);
        x.precioVentaUsd = (Number(x.margen) / 100) * Number(x.costoUnitarioTotal);
        x.precioVentaUsdIva = x.precioVentaUsd * 1.16;
        x.precioVenta = x.precioVentaUsd * tipoDeCambio;
        x.precioVentaIva = x.precioVenta * 1.16;
        setProducts(products => [...products]);
    }

    const renderCostoTotal = () => {
        if (products.length === 0) return null;
        return (
            <>
                <Divider className='my-3' textAlign="center">
                    <CustomChip variant='outlined' estatus='DIAGNOSTICADO' label='Costo Total (USD)' className='text-bold' />
                </Divider>

                <TableContainer sx={{ backgroundColor: '#ABC27033' }}>
                    <Table>
                        <TableHead>
                            <TableRow hover >
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                <TableCell align='left' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Mix Value</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Costo Total</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Costo Unitario</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {products.map((ref, i) => (
                                <TableRow hover key={i} >
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='left'>{ref.nombre}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{formatMoney(ref.mixValue)} %</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.costoTotal)}`}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.costoUnitarioTotal)}`}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Divider className='my-3' textAlign="center">
                    <CustomChip variant='outlined' estatus='DIAGNOSTICADO' label='Perecio de Venta' className='text-bold' />
                </Divider>

                <TableContainer sx={{ backgroundColor: '#47A99233' }}>
                    <Table>
                        <TableHead>
                            <TableRow hover >
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                <TableCell align='left' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Costo Unitario</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Margen %</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Precio Salida s/IVA (USD)</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Precio Salida c/IVA (USD)</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Precio Salida s/IVA (MXN)</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Precio Salida c/IVA (MXN)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {products.map((ref, i) => (
                                <TableRow hover key={i} >
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='left'>{ref.nombre}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.costoUnitarioTotal)}`}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>
                                        <FormControl required sx={{ m: 1, maxWidth: '90px' }} style={{ display: 'flex' }}>
                                            <TextField size='small' name='margen' label="Margen %" variant="outlined" value={ref.margen} onChange={(e) => editMargen(e, ref.id)} />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.precioVentaUsd)}`}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.precioVentaUsdIva)}`}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.precioVenta)}`}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em' }} align='right'>{`$ ${formatMoney(ref.precioVentaIva)}`}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <br />
                {/* <div className='d-flex justify-content-end'>
                    <Button variant='contained' color='success' className='m-1' onClick={(e) => handleSubmit(e)}>Guardar &nbsp;&nbsp; <i className='fad fa-save' style={{ transform: 'scale(1.3)' }}></i></Button>
                </div> */}
            </>
        )
    }

    const handleSave = async (e) => {

        e.preventDefault();
        setDisabled(true);
        const batch = {
            noPedido: noPedido,
            proveedor: proveedor,
            categoria: categoria,
            fechaDePedido: fechaDePedido,
            fechaDeEntrega: fechaDeEntrega,
            tipoDeCambio: Number(tipoDeCambio),
            estatus: 'Pendiente',
            productos: products,
            gastos: gastos,
            subtotalGastos: subtotalGastos,
        }

        try {
            const res = await axios.post('/api/batchs/', { batch: batch });
            if (res.status === 200) {
                setApiRes({ show: true, message: 'Pedido agregado correctamente.', severity: 'success' });
                // setTimeout(() => {
                //     navigate('/pedidos');
                // }, 2000);
            }
        } catch (err) {
            setApiRes({ show: true, message: 'Error al agregar el pedido.', severity: 'error' });
            console.log(err);
        }
    }

    return (
        <>
            <Container maxWidth='xxl' style={{ marginTop: '10px' }}>
                <Paper sx={{ padding: '24px 0px' }} elevation={3}>

                    <Container maxWidth='xxl'>
                        <Box className='text-center' >
                            <Typography variant='h4' style={{ fontWeight: 700 }}>Agregar pedido</Typography>
                        </Box>

                        <Button size='small' variant='outlined' onClick={() => navigate('/pedidos')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>

                        <Divider variant="middle" className='my-3' />

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        freeSolo={false}
                                        onInputChange={(event, newInputValue) => setProveedor(newInputValue)}
                                        inputValue={proveedor}
                                        aria-multiline='true'
                                        options={suppliers.map((option) => option.name)}
                                        renderInput={(params) => <TextField {...params} label='Proveedor' helperText='Seleccione un proveedor de la lista.' />}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        freeSolo={false}
                                        onInputChange={(event, newInputValue) => setCategoria(newInputValue)}
                                        inputValue={categoria}
                                        aria-multiline='true'
                                        options={categories.map((option) => option.nombre)}
                                        renderInput={(params) => <TextField {...params} label='Categoría' helperText='Seleccione una categoría de la lista.' />}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="# Pedido" variant="outlined" value={noPedido} onChange={(e) => setNoPedido(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <DatePicker
                                        label="Fecha de Pedido"
                                        format="dd/MM/yyyy"
                                        value={fechaDePedido}
                                        onChange={(newValue) => setFechaDePedido(newValue)}
                                        slotProps={{ textField: { variant: 'outlined' } }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <DatePicker
                                        label="Fecha de Entrega"
                                        format="dd/MM/yyyy"
                                        value={fechaDeEntrega}
                                        onChange={(newValue) => setFechaDeEntrega(newValue)}
                                        slotProps={{ textField: { variant: 'outlined' } }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container spacing={3} sx={{ my: 1 }}>
                            <Grid item xs={12} md={4}>
                                <Button variant="contained" color="secondary" onClick={handleOpen}>Agregar productos &nbsp; <i className="fad fa-plus-circle"></i></Button>
                            </Grid>
                        </Grid>

                        {renderProducts()}
                        {renderCostos()}
                        {renderCostosTable()}
                        {renderCostoTotal()}

                        <hr></hr>
                        <Grid container spacing={3} sx={{ display: 'flex', justifyContent: 'end' }}>
                            <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'end' }}>
                                <Button variant="contained" color="success" onClick={(e) => handleSave(e)} disabled={disabled}>Guardar &nbsp; <i className="fad fa-save"></i></Button>
                            </Grid>
                        </Grid>

                    </Container>
                </Paper>
                {renderSearchModal()}
            </Container>
            <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
        </>
    )
}

export default AgregarPedido